import { Environment } from "shared/core/Environment";

const CustomersCdp = [
  { id: 8, name: "Bonafini Massas" },
  { id: 24, name: "Rebels" },
  { id: 25, name: "Cabana Burger" },
  { id: 26, name: "Let's Poke_antigo_2" },
  { id: 27, name: "Let's Poke" },
  { id: 28, name: "Tasty Salad Shop" },
  { id: 30, name: "Greenjoy" },
  { id: 31, name: "Gua.co" },
  { id: 32, name: "Demo Pedro" },
  { id: 33, name: "SmartInsights" },
  { id: 34, name: "Cia Tradicional de Comércio" },
  { id: 35, name: "Pizza For Fun" },
  { id: 36, name: "Bom Beef Burgers" },
  { id: 37, name: "Lig-Lig" },
  { id: 38, name: "Chefinhos" },
  { id: 39, name: "Isabela Akkari" },
  { id: 40, name: "Pizzaria Delicious" },
  { id: 41, name: "Pizzaria Delicious" },
  { id: 42, name: "Smart Insights" },
  { id: 43, name: "Sucão" },
  { id: 44, name: "Burdog" },
  { id: 49, name: "Coco Bambu" },
  { id: 50, name: "Hugg's Burger Brasil" },
  { id: 51, name: "The Famous" },
  { id: 52, name: "Azilados" },
  { id: 53, name: "demosamio" },
  { id: 54, name: "demofabio" },
  { id: 55, name: "Rei do Café" },
  { id: 56, name: "Olga Testes" },
  { id: 57, name: "Peixe Ao Cubo" },
  { id: 58, name: "Restaurante Modelo" },
  { id: 59, name: "Sí Señor!" },
  { id: 60, name: "Dog do Eixo" },
  { id: 61, name: "Sushiloko" },
  { id: 62, name: "Hum Burguer" },
  { id: 63, name: "Brasil Vexado" },
  { id: 64, name: "Seringueira" },
  { id: 65, name: "Seringueira Express" },
  { id: 66, name: "Dipz" },
  { id: 67, name: "O Berro" },
  { id: 68, name: "Jet Pizzas" },
  { id: 69, name: "Jappa da Quitanda" },
  { id: 70, name: "Cia das Sopas" },
  { id: 71, name: "Andiamo" },
  { id: 72, name: "Piadina" },
  { id: 73, name: "The Good Cop Donuts" },
  { id: 74, name: "Vamp Lanches" },
  { id: 75, name: "Grupo YenLin" },
  { id: 76, name: "Pits Burger" },
  { id: 77, name: "Manda Brasa" },
  { id: 78, name: "Roister" },
  { id: 79, name: "Borger Burger" },
  { id: 80, name: "Haro Sushi" },
  { id: 81, name: "Shiroi-Ki" },
  { id: 82, name: "Take a Juice" },
  { id: 83, name: "Famous Group" },
  { id: 84, name: "Mundo Animal" },
  { id: 85, name: "LivGarden" },
  { id: 86, name: "1900" },
  { id: 87, name: "Estação Campineira" },
  { id: 88, name: "Fat Buddha" },
  { id: 89, name: "Showroom Netlogic" },
  { id: 90, name: "Açaí Fusion" },
  { id: 91, name: "Bar do Zeca" },
  { id: 92, name: "BFW Club" },
  { id: 93, name: "Menu Brands" },
  { id: 94, name: "Di Paolo" },
  { id: 95, name: "Alemão Burger" },
];

export default CustomersCdp;
